module.exports = __webpack_public_path__ + "img/feelmusic.eff21b48.jpg";